import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import { useSaveUser } from './_requests/saveUser'
import { useUser } from './_load/UserLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import PasswordSection from './sections/PasswordSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditUserForm = () => {
  const { initialState } = useModalData() || {}
  const user = useUser()
  const [onSubmit, { loading, error }] = useSaveUser()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={user || initialState || {}}>
      <PasswordSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditUserForm
